<div
  class="flex flex-col justify-between"
  [class]="label() ? 'justify-between' : 'justify-end'">
  @if (label()) {
    <label
      class="text-sm"
      [class.text-neutral-300]="disabled()"
      [class.cursor-not-allowed]="disabled()"
      [class.text-neutral-900]="!disabled()"
      [class.font-medium]="!disabled()"
      [class.label-required]="required()"
      [for]="inputFormControlName()">
      {{ label() }}
    </label>
  }

  @let parenthasErrors =
    isDualLangEnabled() &&
    parentFormGroup.errors &&
    (parentFormGroup.dirty || parentFormGroup.touched);

  @let hasErrors =
    (childControl &&
      ((childControl.errors && childControl.dirty) ||
        (childControl.errors && childControl.touched))) ||
    parenthasErrors;

  <div
    class="tiptap border border-neutral-300 rounded-md bg-white h-fit"
    [class.border-neutral-200!]="editor && disabled()"
    [class.has-errors]="editor && hasErrors"
    [class.text-neutral-300!]="disabled()">
    <div
      [class.resize-y]="canResize()"
      [class.overflow-auto]="canResize()"
      class="flex flex-col justify-between min-h-[13rem] max-h-[50rem]">
      @if (editor) {
        <!-- Editor -->
        <div
          [class.text-destructive-300]="editor && hasErrors"
          class="relative grow h-[12rem] overflow-auto after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-6 after:bg-gradient-to-t after:from-white after:to-transparent after:pointer-events-none">
          <tiptap-editor [editor]="editor" />
        </div>

        <!-- Toolbar -->
        <lib-tiptap-editor-menu
          [editor]="editor"
          [maxLength]="maxLength()"
          [characterCount]="characterCount()"
          [disabled]="disabled()">
          <ng-content select="[tiptap-toolbar]" />
        </lib-tiptap-editor-menu>
      }
    </div>
  </div>
</div>
